import { Stack, Typography } from '@mui/material';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { CPLink } from './CPLink';
import { useTranslation } from 'react-i18next';

interface SsoSigninBannerProps {
  onClick?: () => void;
}

export const SsoSigninBanner = ({ ...props }: SsoSigninBannerProps) => {
  const [t] = useTranslation();

  return (
    <Stack
      padding={2}
      sx={{
        alignItems: 'flex-start',
        backgroundColor: '#E8F3FC',
        borderRadius: 1,
      }}
    >
      <Typography fontSize={16} fontWeight={500}>
        <SchoolOutlinedIcon color="primary" className="me-2" />
        {t('signin.banner.title')}
      </Typography>

      <Typography
        fontSize={14}
        fontWeight={400}
        align="left"
        sx={{ marginLeft: 4, marginTop: 2 }}
      >
        {t('signin.banner.content')}
      </Typography>

      <CPLink
        label={t('signin.banner.action')}
        underline="always"
        onClick={props.onClick}
        sx={{ marginLeft: 4 }}
      />
    </Stack>
  );
};
